/**
 * @generated SignedSource<<9de6bd882c92ed44943c2cb8e04d5f96>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuildTypeInfoPanelQuery$variables = {
  locator: string;
};
export type BuildTypeInfoPanelQuery$data = {
  readonly builds: {
    readonly " $fragmentSpreads": FragmentRefs<"BuildTypeInfoPanelFragment">;
  } | null;
};
export type BuildTypeInfoPanelQuery = {
  response: BuildTypeInfoPanelQuery$data;
  variables: BuildTypeInfoPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "locator",
    "variableName": "locator"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BuildTypeInfoPanelQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Builds",
        "kind": "LinkedField",
        "name": "builds",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BuildTypeInfoPanelFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BuildTypeInfoPanelQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Builds",
        "kind": "LinkedField",
        "name": "builds",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Build",
            "kind": "LinkedField",
            "name": "build",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rawId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "queuedDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "finishDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProgressInfo",
                "kind": "LinkedField",
                "name": "runningInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "elapsedSeconds",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "64281075d5374cead1ea133dff5b06a6",
    "id": null,
    "metadata": {},
    "name": "BuildTypeInfoPanelQuery",
    "operationKind": "query",
    "text": "query BuildTypeInfoPanelQuery(\n  $locator: String!\n) {\n  builds(locator: $locator) {\n    ...BuildTypeInfoPanelFragment\n  }\n}\n\nfragment BuildStatsBarFragment on Build {\n  rawId\n  startDate\n  queuedDate\n  finishDate\n  runningInfo {\n    elapsedSeconds\n  }\n  status\n  state\n  ...useRunningBuildUpdaterRelayFragment\n}\n\nfragment BuildTypeInfoPanelFragment on Builds {\n  build {\n    rawId\n    startDate\n    state\n    id\n  }\n  ...BuildsTimelineFragment\n}\n\nfragment BuildsTimelineFragment on Builds {\n  build {\n    rawId\n    state\n    startDate\n    queuedDate\n    finishDate\n    runningInfo {\n      elapsedSeconds\n    }\n    ...BuildStatsBarFragment\n    id\n  }\n}\n\nfragment useRunningBuildUpdaterRelayFragment on Build {\n  id\n  rawId\n  state\n}\n"
  }
};
})();

(node as any).hash = "3a2c0615ab7aa500bce51b0c4dafcba0";

export default node;
